import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { Section } from '@omni/ai/features/card.schema';

/** One dated node on the timeline. */
type TimelineEvent = Extract<Section, { type: 'timeline' }>['items'][number];

/**
 * `timeline` section: an ordered vertical run of dated event nodes joined by a
 * connector rail — recent activity or upcoming actions. Each node's dot tone
 * comes from the optional `accent`, mapping to the shared callout token set.
 */
@Component({
  selector: 'card-timeline',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-timeline.component.html',
  styleUrls: ['./card-timeline.component.scss'],
})
export class CardTimelineComponent {
  @Input() title: string | null = null;
  @Input() items: TimelineEvent[] = [];

  /** Maps an event accent to its dot modifier class; defaults to the neutral dot. */
  dotClass(accent: TimelineEvent['accent']): string {
    return accent ? `card-timeline__dot--${accent}` : '';
  }
}
